<div *ngIf="!videoLogService.image" style='padding-top: 300px;'></div>
<div id="videoLogViewerMessage" class="video-log-viewer-message">
    <span *ngIf="!videoLogService.image">No Video Log image available for this location</span>
</div>

<div id="mapClickActive" class="map-click-toggle" [ngStyle]="{'top': topPx, 'bottom': bottomPx}"  title="Disable Map Clicks" [hidden]="hidePopUpButtons">
    <label>
        <input id="mapClickToggleCheckBox" type="checkbox" [checked]="mapClickActive" (change)="mapClickActive = !mapClickActive" hidden>
        <span class="icon-ui-map-pin"></span>
    </label>
</div>

<div id="swapPanel" class="swap-btn" style="right:50px;" [ngStyle]="{'top': topPx, 'bottom': bottomPx}" title="Toggle Extended View" [hidden]="hideSwapBtn">
    <label>
        <input id="swapPanelBtn" type="button" (click)="swapPanels(); resetImages()" hidden>
        <span [ngClass]="showThreeImages ? 'icon-ui-up-arrow' : 'icon-ui-down-arrow'"></span>
    </label>
</div>

<div id="resetButton" class="swap-btn" style="right:100px;"
     [ngStyle]="{'top': topPx, 'bottom': bottomPx}" title="Reset Image Positions and Visibility" [hidden]="!showThreeImages || !videoLogService.image">
    <label>
        <input id="resetBtn" type="button" (click)="resetImages()" hidden>
        <span class="icon-ui-refresh"></span>
    </label>
</div>


<div id="imageContainer" style="position:relative; min-height:100%; width:100%;">

    <div #leftImageDiv class="side-image"
         [draggable]="true" [hidden]="!(videoLogService.image && showThreeImages) || !showLeft"
         (wheel)="zoomImage($event, 0)"
         (click)="moveImageToTop(0)">

        <img #leftImage id="videoLogImageLeft"
             style="width: 100%; height: 100%;" [hidden]="!(videoLogService.image && showThreeImages) || !showLeft"
             [src]="videoLogService.image?.lurl ? videoLogService.image?.lurl : ''" [alt]="videoLogService.image?.imageName3" title="{{toolTipText}}"
             (dblclick)="openPopUpWindow('l')" (click)="moveImageToTop(0)" />
    </div>

    <div #middleImageDiv  class="middle-image" [draggable]="showThreeImages"
         [hidden]="!videoLogService.image || !showCenter" (wheel)="zoomImage($event, 1)"
         [ngClass]="{'middle-image-three-image' : showThreeImages}"
         (click)="moveImageToTop(1)">

        <img #middleImage id="videoLogImageMiddle"
             style="width: 100%; height: 100%;" [hidden]="!videoLogService.image || !showCenter"
             [src]="videoLogService.image?.url ? videoLogService.image?.url : ''" [alt]="videoLogService.image?.imageName1" title="{{toolTipText}}"
             (dblclick)="openPopUpWindow('m')" (click)="moveImageToTop(1)">
    </div>

    <div #rightImageDiv class="side-image"
         [draggable]="true" [hidden]="!(videoLogService.image && showThreeImages) || !showRight"
         (wheel)="zoomImage($event, 2)"
         (click)="moveImageToTop(2)">

        <img #rightImage id="videoLogImageRight"
             style="width: 100%; height: 100%;" [hidden]="!(videoLogService.image && showThreeImages) || !showRight"
             [src]="videoLogService.image?.rurl ? videoLogService.image?.rurl : ''" [alt]="videoLogService.image?.imageName2" title="{{toolTipText}}"
             (dblclick)="openPopUpWindow('r')" (click)="moveImageToTop(2)">
    </div>
</div>

<div id="videoLogUrl" class="video-log-url" *ngIf="videoLogService.image && videoLogService.videoLogUrl">
    <a [href]="videoLogService.videoLogUrl" target="_blank">PennDOT VideoLog</a>
</div>
